import qs from 'qs'
import axios from 'axios'
import store from 'store'
import router from 'router'
import { Loading, MessageBox, Message  } from 'element-ui';
import url from './hostconfig'
import VueCookies from "vue-cookies"
import { model, config } from 'service/model'

const ISPE = config.env
class Fetch {
    constructor() {
        this.needLoadingRequestCount = 0
        this.url = ''
        this.loading = null
        this.timeout = 6e4
        this.initialize()
    }
    startLoading() {
        this.loading = Loading.service({
            lock: true,
            text: '请稍后...',
            spinner:"",
            customClass:'global-loading',
            background: 'rgba(256, 256, 256, 0.5)'
        })
      }
       
    endLoading() {
        this.loading.close()
    }

    showFullScreenLoading() {
        if (this.needLoadingRequestCount === 0) {
            this.startLoading()
        }
        this.needLoadingRequestCount++
    }
 
    tryHideFullScreenLoading() {
        if (this.needLoadingRequestCount <= 0) return
            this.needLoadingRequestCount--
        if (this.needLoadingRequestCount === 0) {
            this.endLoading()
        }
        
    }

    initialize() {
        this.url = url
        axios.defaults.timeout = this.timeout
        axios.defaults.baseURL = this.url
        axios.defaults.retry = 0
        axios.defaults.retryDelay = 2e4
        this.interceptor()
    }

    interceptor() {
        axios.interceptors.request.use((config) => {
            let token = VueCookies.get('token')
            let user_mac_address = store.getters['global/userLog'].user_mac_address
            config.data = qs.stringify(config.data)
            config.headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded'
            }
            if(token){
                config.headers.Authorization = token
            }
            if(user_mac_address && ISPE){
                config.headers['userMacAddress'] = user_mac_address
            }
            let browser = navigator.appName
            let b_version = navigator.appVersion
            let version = b_version.split(";")
            let trim_Version = version[1] && version[1].replace(/[ ]/g, "") || ''
            if ( browser == "Microsoft Internet Explorer" && trim_Version == "MSIE9.0" ) {
                if (config.url.indexOf('?') > 0) {
                    config.url = config.url + "&" + config.data
                }
                else {
                    config.url = config.url + "?" + config.data
                }
            }
            config.cancelToken = new axios.CancelToken(function (cancel) {
                store.commit('global/PUSHHTTP', {cancelToken: cancel})
            })
            return config
        }, error => {
            return Promise.reject(error);
        })

        axios.interceptors.response.use((response) => {
            if (response.data) {
                if (response.data.code == 0) {
                    return response.data
                } else {
                    return this.handleResposeError(response.data)
                }
            }
            return response
        }, error => {
            /* this.tryHideFullScreenLoading() */
            // network  timeout
            if (axios.isCancel(error)) {
                return new Promise(() => {});
            }
            this.handleNetError(error)

            let config = error.config;
            // If config does not exist or the retry option is not set, reject
            if (!config || !config.retry) return Promise.reject(error);

            // Set the variable for keeping track of the retry count
            config.__retryCount = config.__retryCount || 0;

            // Check if we've maxed out the total number of retries
            if (config.__retryCount >= config.retry) {
                // Reject with the error
                return Promise.reject(error);
            }

            // Increase the retry count
            config.__retryCount += 1;

            // Create new promise to handle exponential backoff
            let backoff = new Promise(function(resolve) {
                setTimeout(function() {
                    resolve();
                }, config.retryDelay || 1);
            });

            // Return the promise in which recalls axios to retry the request
            return backoff.then(function() {
                return axios(config);
            });
        })
    }
   
    fetch(model, params) {
        let _params = params ? ( params.params || {} ) : {}
        let _router = params ? params.router : ''
        let url = model.url
        if(url.includes('Export')){
            axios.defaults.timeout = 3e4
        }
        if(_router){
            if(_router instanceof Array){
                for(var r of _router){
                    url += '/' + r
                }
            }else{
                url += '/' + _router
            }
        }
        if (model.method == 'post') {
            return this.post(url, _params)
        }else if (model.method == 'put'){
            return this.put(url, _params)
        }else if (model.method == 'delete'){
            return this.delete(url, _params)
        }else{
            return this.get(url, _params)
        }
    }

    get(url, params) {
        return new Promise(function(resolve, reject) {
            axios.get(url, {
                params : params
            })
            .then( data => {
                if (data.code == 0) {
                    resolve(data.result)
                } else {
                    reject(data.msg)
                }
            }, data => {
                reject(data.msg)
            })
        })
    }

    post(url, params) {
        return new Promise(function(resolve, reject) {
            axios.post(url, params)
            .then( data => {
                if (data.code == 0) {
                    resolve(data.result)
                } else {
                    const {list} = data.result || {}
                    const {msg} = data
                    if(list){
                        reject({msg,list})
                    }else {
                        reject(msg)
                    }
                }
            }, data => {
                reject(data.msg)
            })
        })
    }

    put(url, params) {
        return new Promise((resolve,reject) => {
            axios.put(url, params)
            .then( data => {
                if (data.code == 0) {
                    resolve(data.result)
                } else {
                    reject(data.msg)
                }
            }, data => {
                reject(data.msg)
            })
        })
    }

    delete(url, params) {
        return new Promise((resolve,reject) => {
            axios.delete(url, {
                params : params
            })
            .then( data => {
                if (data.code == 0) {
                    resolve(data.result)
                } else {
                    reject(data.msg)
                }
            }, data => {
                reject(data.msg)
            })
        })
    }

    handleNetError(error) {
        if(error.message.indexOf('timeout')!=-1){
            error.msg = '请求超时'
            return error
        }else if(error.response) {
            switch (error.response.status) {
                case 401:
                store.commit('auth/EXIT');
                router.replace({
                    path: '/login',
                })
                break
                case 405:

                break
                case 500:
                    error.msg = '服务器错误'
                    //return error
                break
            }
        }else{
            error.msg = '系统错误'
            return error
        }
    }

    handleResposeError(data) {
        if (data.code == 50010) {
            store.commit('global/CLEARHTTP')
            if(!data.msg){
                data.msg = '账号已过期，请重新登录'
            }
            MessageBox.alert(data.msg, '提示',{
                distinguishCancelAndClose: true,
                confirmButtonText: '重新登录',
                center: true,
                showClose:false,
            }).then(() => {
                store.commit('auth/EXIT');
                router.replace({
                    path: '/login',
                })
            })
        }else{
            /* Message({
                type: 'error',
                message: data.msg,
                customClass:'gl-z-index',
            }) */
        }
        return data
    }
}
const xhr = new Fetch()
export default xhr


// WEBPACK FOOTER //
// ./src/service/index.js